module.exports = __webpack_public_path__ + "files/observa4.35cffc21d82067302ff85dcfda6257b4.pdf";